import { TLocale } from '@internal/utils/machine/i18n/Locale';
import { useRouter } from 'next/router';
import { SystemPageKey } from 'page/SystemPageKey';
import { useCallback } from 'react';
import { urlFor } from './urls/urlFor';

export const useMachineComparisonRouting = (locale: TLocale) => {
    const {
        push,
        replace,
        query: { ip },
    } = useRouter();

    const gotoCompareMachinesPage = useCallback(
        (
            machineGroupIds: string[],
            params?: {
                replace?: boolean;
                shallow?: boolean;
            },
        ) => {
            const ids = machineGroupIds.map(id => id.toLowerCase());
            const url = urlFor(locale, {
                key: SystemPageKey.CompareMachines,
                pathParams: {
                    machineGroupId0: ids[0],
                    machineGroupId1: ids[1],
                    machineGroupId2: ids[2],
                },
                queryParams: {
                    ip: ip?.toString(),
                },
            });

            if (params?.replace) {
                replace(url, undefined, { shallow: params?.shallow });
            } else {
                push(url, undefined, { shallow: params?.shallow });
            }
        },
        [locale, ip, replace, push],
    );

    return { gotoCompareMachinesPage };
};
